export default __webpack_public_path__ + "static/media/BGRNew.c74a2ead.png";